import { render, staticRenderFns } from "./AccountCreation.vue.vue?vue&type=template&id=257bfcc4&"
import script from "./AccountCreation.vue.vue?vue&type=script&lang=js&"
export * from "./AccountCreation.vue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports